"use client";

import { useUser } from "@clerk/nextjs";

// Client-side admin check. `publicMetadata` is exposed on the client User
// object, so this mirrors the server-only `isAdmin()` in lib/admin-auth.ts
// without a network call. Used to let admins preview pro features.
export function useIsAdmin() {
  const { user, isLoaded } = useUser();
  if (!isLoaded) return false;
  return user?.publicMetadata.role === "admin";
}
